import { Button, strIsNullOrEmpty } from '@fox/atoms';
import { FlexColumnCentered } from '@fox/layout';
import React, { useState } from 'react';
import { useContentContext } from '../../content-context';
import { redirect } from '../membership-form-template/util';
import { IMemberLoginStatusProps } from './contracts';

export const MemberLoginStatus: React.FC<IMemberLoginStatusProps> = ({ loginRedirectUrl, logoutRedirectUrl, variant }) => {
	const { requestToken, isLoggedIn } = useContentContext();
	const [submitted, setSubmitted] = useState<boolean>(false);

	const buttonVariant = !strIsNullOrEmpty(variant) ? variant : 'primary';

	const logOut = async () => {
		setSubmitted(true);
		const res = await fetch('/Umbraco/Api/Membership/HandleLogout', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				RequestVerificationToken: requestToken
			},
			body: ''
		});
		if (res.ok) {
			const jsonRes = await res.json();
			if (jsonRes.success === false) {
				setSubmitted(false);
			} else {
				if (!strIsNullOrEmpty(logoutRedirectUrl?.url)) {
					if (logoutRedirectUrl.target == '_blank') {
						window.open(logoutRedirectUrl.url, logoutRedirectUrl.target);
					} else {
						window.location.href = logoutRedirectUrl.url;
					}
				} else {
					//really wish i had a better idea here
					window.location.reload();
				}
			}
		} else {
			setSubmitted(false);
		}
	};

	if (isLoggedIn) {
		return (
			<FlexColumnCentered style={{ justifyContent: 'center', height: '100%' }}>
				<Button type="submit" onClick={logOut} disabled={submitted} size="large" variant="primary">
					Log out
				</Button>
			</FlexColumnCentered>
		);
	} else if (!strIsNullOrEmpty(loginRedirectUrl.url)) {
		return (
			<FlexColumnCentered style={{ justifyContent: 'center', height: '100%' }}>
				<Button
					onClick={() => {
						redirect(loginRedirectUrl);
					}}
					type="submit"
					disabled={submitted}
					size="large"
					variant={buttonVariant}
				>
					Log in
				</Button>
			</FlexColumnCentered>
		);
	} else {
		return (
			<FlexColumnCentered style={{ justifyContent: 'center', height: '100%' }}>
				<Button type="submit" disabled={true} size="large" variant={buttonVariant}>
					Logged out
				</Button>
			</FlexColumnCentered>
		);
	}
};
